<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" :title="baseForm.brandId ? (isEdit ? '编辑品牌' : '查看品牌') : '新增品牌'" v-bind="$attrs" v-on="$listeners">
    <div class="edit-box flex-c-e" v-show="baseForm.brandId">
      <el-button v-if="mixinHasPermi(['product:brand:update'])" type="primary" class="edit" @click="toggleEdit">{{
        isEdit ? "取消编辑" : "编辑"
      }}</el-button>
    </div>
    <div class="el-dialog-body-child">
      <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules"
        :disabled="!!(!isEdit && baseForm.brandId)" label-width="120px">
        <el-form-item class="all" label="品牌名称" prop="brandName">
          <el-input v-model.trim="dialogForm.brandName" clearable placeholder="请输入品牌项" />
        </el-form-item>
        <el-form-item class="all" label="品牌logo" prop="brandLogoSrcList">
          <xiaobu-upload-img :disabled="!!(!isEdit && baseForm.brandId)" :openCropper="false"
            @imgChange="handleImgChange" :max="1" :imgList="dialogForm.brandLogoSrcList"></xiaobu-upload-img>
        </el-form-item>
        <el-form-item class="all" label="备注" prop="remark">
          <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
            placeholder="请输入备注" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          !baseForm.brandId || isEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button type="primary" @click="submitForm" v-show="!baseForm.brandId || isEdit">确 定</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import XiaobuUploadImg from "@/components/upload-img/index.vue"
import { commonApi, brandApi } from "@/api"
export default {
  name: "BrandDialog",
  components: {
    XiaobuUploadImg
  },
  props: {
    // 是否是编辑
    isUpdate: {
      type: Boolean,
      default: false
    },
    // 品牌数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    /** 检查用户名是否已存在 */
    const checkbrandName = (rule, value, callback) => {
      brandApi
        .judgeExist({ brandName: value, brandId: this.baseForm.brandId })
        .then((data) => {
          if (data.validateResult) {
            callback()
          } else {
            callback(data.msg)
          }
        })
    }
    return {
      isEdit: false, // 是否是在编辑
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {
        brandName: [
          {
            required: true,
            message: "请输入品牌名称",
            trigger: ["blur", "change"]
          },
          { validator: checkbrandName, trigger: "blur" }
        ],
        brandLogoSrcList: [
          {
            required: true,
            message: "请上传品牌logo",
            trigger: "change"
          }
        ]
      }
    }
  },
  watch: {
    isUpdate(val) {
      this.isEdit = val
    },
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.dialogForm = JSON.parse(JSON.stringify(val))
        this.dialogForm.deleteFiles = ""
        if (this.dialogForm.brandLogoSrc) {
          this.dialogForm.brandLogoSrcList = [{
            name: "品牌logo",
            url: this.dialogForm.brandLogoSrc
          }]
        } else {
          this.dialogForm.brandLogoSrcList = []
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 图片改变事件
    handleImgChange(brandLogoSrcList) {
      this.dialogForm.brandLogoSrcList = brandLogoSrcList
      this.$refs.dialogFormRef.validateField("brandLogoSrcList")
    },
    // 编辑或取消编辑
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.isEdit = false
      this.dialogForm = JSON.parse(JSON.stringify(this.baseForm))
      this.dialogForm.deleteFiles = ""
      if (this.dialogForm.brandLogoSrc) {
        this.dialogForm.brandLogoSrcList = [{
          name: "品牌logo",
          url: this.dialogForm.brandLogoSrc
        }]
      } else {
        this.dialogForm.brandLogoSrcList = []
      }
      this.$nextTick(() => {
        this.$refs.dialogFormRef && this.$refs.dialogFormRef.clearValidate()
      })
    },
    // 重置表单
    resetForm() {
      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["dialogFormRef"].validate(async valid => {
        if (valid) {
          const formData = new FormData()
          const targetItem = this.dialogForm.brandLogoSrcList[0]
          if (targetItem.raw) {
            formData.append("file", targetItem.raw, targetItem.name)
            const data = await commonApi.upload(formData)
            if (!data) { return }
            // 多传删除的图片地址 字符串格式 英文逗号隔开 
            this.dialogForm.deleteFiles = this.dialogForm.brandLogoSrc
            this.dialogForm.brandLogoSrc = data.url
          }
          const params = JSON.parse(JSON.stringify(this.dialogForm))
          delete params.brandLogoSrcList
          //更新
          if (params.brandId) {
            brandApi.updateItem(params).then((data) => {
              this.$modal.msgSuccess("编辑品牌成功")
              this.$emit("close")
              this.$emit("successs")
            })
          } else {
            //新增
            brandApi.createItem(params).then((data) => {
              this.$modal.msgSuccess("新增品牌成功")
              this.$emit("close")
              this.$emit("successs")
            })
          }
        }
      })
    }
  }
}
</script>
